import {Observable, Subscription} from 'rxjs/Rx'

export class SubscriptionHelper {

  private static _subscriptionStore: WeakMap<any, Set<Subscription>> = new WeakMap<any, Set<Subscription>>()

  constructor(private _component: any) {}

  public track(subscription: Subscription) {
    SubscriptionHelper.track(this._component, subscription)
  }

  public unsubscribeAll() {
    SubscriptionHelper.unsubscribeAll(this._component)
  }

  private static track(component: any, subscription: Subscription) {
    if (!(subscription instanceof Subscription)) {
      throw `Expected a subscription, but got "${subscription}" instead. Cannot track provided object.`
    }

    let existingSubscriptions = SubscriptionHelper._subscriptionStore.get(component) || new Set<Subscription>()
    existingSubscriptions.add(subscription)
    SubscriptionHelper._subscriptionStore.set(component, existingSubscriptions)
  }

  private static unsubscribeAll(component: any) {
    let existingSubscriptions = SubscriptionHelper._subscriptionStore.get(component) || new Set<Subscription>()
    existingSubscriptions.forEach(subscription => subscription.unsubscribe())
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/subscription-helper.ts